import { Component } from 'vue-property-decorator';
import ReportBase from '@/views/reports/report-base';
import { mixins } from 'vue-class-component';

import ColumnSettingsApi from '@/services/rest/bemob/column-settings';
import MetricsMixin from '@/views/reports/pickers/base/metrics-mixin';


@Component
export default class Columns extends mixins<ReportBase, MetricsMixin>(ReportBase, MetricsMixin) {
  columnSettingsApi: ColumnSettingsApi = new ColumnSettingsApi();

  get tableHeaders() {
    const { view, treeLevels} = this.$store.getters.tableQueryForCurrentTab;
    const { dimensions } = this.$store.state.reportColumns
    let result = this.selectedTableMetrics
    if(view==='table'){
      const treeLevelsReal = treeLevels?.filter(item=>!!item)
      if (treeLevelsReal) {
        const treeColumns = treeLevelsReal.map(key => dimensions[key].mainColumn)
        // check if already added once
        if(treeColumns[0]!==this.selectedTableMetrics[1]){
          const newSelectedTableMetrics = this.selectedTableMetrics
          newSelectedTableMetrics.splice(1, 0, ...treeColumns)
          result = newSelectedTableMetrics
        }
      }
    }

    if(this.$store.state.table.reportBoostEnabled) {
      return result.filter((item)=>!this.$store.state.reportColumns.metrics.includes(item))
    }

    return result;
  }

  get columnSettings() {
    return this.$store.getters.reportParams
  }
}
